const settings = {
    development: {
      baseURL: 'http://localhost:8000/api',
    },
    production: {
      baseURL: 'https://mma.nextai.it/api',
    },
    test: {
      baseURL: 'https://mma.socialitai.it/api',
    },
  };
  
  const env = process.env.REACT_APP_ENV && process.env.REACT_APP_ENV in settings ? process.env.REACT_APP_ENV : 'development';
  export const config = settings[env];